import {OrderHistoryContext} from '../state/orderHistoryContext';
import {useContext} from "react";
import {useState, useEffect} from "react";
import {Item} from "../queries/Item";
import {useSubmit} from "./useSubmit";
import {useUserInfo} from "../../userInfo/hooks/useUserInfo";

export const useOrderHistory = ({id}) => {
    const {state: history, dispatch} = useContext(OrderHistoryContext);
    const [loading, setLoading] = useState(true);
    const { profil } = useUserInfo();
    const { getCustomerId } = useSubmit();

    useEffect(async () => {
        setLoading(true);
        console.log('Profil:',profil , "History:", history)
        if (profil && history.length == 0) {
            const customerId = await getCustomerId(profil);
            Item.getHistory(customerId)
                .then(history => {
                    console.log('History:', history);
                    dispatch({ type: "init", payload: history })
                    setLoading(false)
                })
                .catch( () => setLoading(false) )
        } else {
            setLoading(false);
        }

    }, [profil]);

    return {history, loading}
}
